<template>
  <div class="home">
    <navbar :is-active="6"></navbar>
    <div class="body form-page-body">
      <MesasSidebar active="menu" />
      <div class="body__containt form-page-content">
        <div class="page__title form-page-title">
          <open-arrow></open-arrow>
          <div class="page__title-text">
            <h2>Nuevo producto</h2>
            <p class="page__lead">Crea un ítem del menú para asignarlo a mesas desde el módulo POS.</p>
          </div>
        </div>

        <form class="form-card" @submit.prevent="save">
          <div class="form-card__header">
            <div class="form-card__icon">
              <i class="fas fa-utensils"></i>
            </div>
            <div>
              <h3>Producto de menú</h3>
              <p>Los campos con * son obligatorios.</p>
            </div>
          </div>

          <div class="form-grid">
            <label class="field" :class="{ 'field--error': activeClass && !menu_name }">
              <span class="field__label">Nombre *</span>
              <input type="text" v-model="menu_name" maxlength="150" placeholder="Ej. Lomo saltado">
              <span class="field__hint" v-if="activeClass && !menu_name">Ingresa el nombre</span>
            </label>

            <label class="field" :class="{ 'field--error': activeClass && (menu_price === '' || menu_price === null) }">
              <span class="field__label">Precio (S/) *</span>
              <input type="text" v-model="menu_price" @keypress="onlyDecimal" placeholder="Ej. 35.00">
              <span class="field__hint" v-if="activeClass && (menu_price === '' || menu_price === null)">Ingresa el precio</span>
            </label>

            <div class="field">
              <span class="field__label">Estado</span>
              <div class="status-toggle">
                <button type="button" :class="{ active: menu_status === '1' }" @click="menu_status = '1'">Activo</button>
                <button type="button" :class="{ active: menu_status === '0' }" @click="menu_status = '0'">Inactivo</button>
              </div>
            </div>

            <label class="field field--full">
              <span class="field__label">Descripción <em>(opcional)</em></span>
              <textarea v-model="menu_description" rows="3" placeholder="Ingredientes, porción o notas del plato"></textarea>
            </label>
          </div>

          <div class="preview-card">
            <div>
              <p class="preview-card__label">Vista previa</p>
              <p class="preview-card__name">{{ menu_name || 'Nombre del producto' }}</p>
            </div>
            <p class="preview-card__price">S/ {{ previewPrice }}</p>
          </div>

          <div class="form-actions">
            <button type="button" class="btn btn--ghost" @click="cancel" :disabled="saving">
              <i class="fa fa-times"></i> Cancelar
            </button>
            <button type="submit" class="btn btn--primary" :disabled="saving">
              <i class="fa fa-check"></i> {{ saving ? 'Guardando...' : 'Guardar producto' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Navbar from '@/components/NavBar.vue'
import MesasSidebar from '@/components/MesasSidebar.vue'
import OpenArrow from '@/components/OpenArrow.vue'
import '@/static/css/form-card.css'

export default {
  name: 'AddMenuMesas',
  components: {
    Navbar,
    MesasSidebar,
    OpenArrow
  },
  data() {
    return {
      menu_name: '',
      menu_price: '',
      menu_description: '',
      menu_status: '1',
      activeClass: false,
      saving: false
    }
  },
  computed: {
    previewPrice() {
      const value = parseFloat(this.menu_price)
      return Number.isFinite(value) ? value.toFixed(2) : '0.00'
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/login')
    }
  },
  methods: {
    onlyDecimal(evt) {
      evt = evt || window.event
      const charCode = evt.which ? evt.which : evt.keyCode
      if (charCode === 46) return
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      }
    },
    cancel() {
      this.$router.push('/menu-mesas')
    },
    async save() {
      if (!this.menu_name || this.menu_price === '' || this.menu_price === null) {
        this.activeClass = true
        this.$swal({
          icon: 'error',
          title: 'Completar los datos correctamente',
          showConfirmButton: false,
          timer: 2000
        })
        return
      }

      this.saving = true
      const data = {
        menu_name: this.menu_name,
        menu_price: parseFloat(this.menu_price),
        menu_description: this.menu_description || null,
        menu_status: parseInt(this.menu_status, 10),
        menu_company_id: parseInt(localStorage.getItem('company_id'), 10)
      }

      try {
        const res = await axios.post('general/menu-product', data)
        if (res.data.success) {
          this.$swal({
            position: 'center',
            icon: 'success',
            title: 'Producto de menú creado correctamente',
            showConfirmButton: false,
            timer: 2000
          })
          this.$router.push('/menu-mesas')
        } else {
          this.$swal({
            icon: 'error',
            title: res.data.message || 'Ocurrio un error',
            showConfirmButton: false,
            timer: 2500
          })
        }
      } catch (e) {
        const message = (e.response && e.response.data && e.response.data.message)
          ? e.response.data.message
          : 'Ocurrio un error'
        this.$swal({
          icon: 'error',
          title: message,
          showConfirmButton: false,
          timer: 2500
        })
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
